import { useEffect, useState } from "react";
import InputA from "../../components/InputA/InputA";
import { Edit2, Type } from "react-feather";
import './H2Edit.scss'
import { parseStringFromServer } from "../../services/TextConverter";
import { Box, Button, Popper, Typography } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import React from "react";
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';

enum Status {
  standard,
  prepareEdit,
  edit,
  prepareStandard,
}

export default function H2Edit(props: {
  value: string,
  onChange: (newValue: string) => void,
  className?: string,
  startEdit?: () => void,
  endEdit?: () => void,
  usePromt?: boolean,
  resetToOldValue?: () => void,
  oldValue?: string,
  prefix?: string,
  heading?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'h7' | 'h8'
}) {
  const [status, setStatus] = useState(Status.standard)
  const [value, setValue] = useState(props.value)
  const [oldValue, setOldValue] = useState(props.oldValue)
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  useEffect(() => {
    setValue(props.value)
    setOldValue(props.oldValue)
  }, [props.value, props.oldValue])
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen((previousOpen) => !previousOpen);
  };
  function toEdit() {
    if (props.usePromt) {
      const nv = window.prompt('Neuen Tag-Namen angeben', value)
      if (!nv) { return }
      props.onChange(nv)
      return
    }
    if (props.startEdit) {
      props.startEdit()
    }
    setStatus(Status.prepareEdit)
    setTimeout(() => {
      setStatus(Status.edit)
    }, 200)
  }

  function toStandard() {
    setStatus(Status.prepareStandard)
    setTimeout(() => {
      setStatus(Status.standard)
    }, 200)
    if (props.endEdit) {
      props.endEdit()
    }
  }

  const content = <>
    <div
      className='h2EditTitleHolder'
    >
      {
        status !== Status.edit &&
        <span className='h2EditTitle'>
          {props.prefix ? `${props.prefix}: ` : ''}
          {value}
          <Button
            onClick={toEdit}
            sx={{marginLeft: '-16px'}}
          >
            <EditIcon
              sx={{fontSize: '16px', marginTop: '-4px'}}
            />
            
          </Button>
          { oldValue !== undefined &&
            <>
            <Button
              onClick={handleClick}
            >
              <ChangeCircleIcon />
            </Button>

            <Popper
              anchorEl={anchorEl}
              placement="bottom-start"
              disablePortal={false}
              sx={{zIndex: 1}}
              modifiers={[
                {
                  name: 'flip',
                  enabled: true,
                  options: {
                    altBoundary: true,
                    rootBoundary: 'document',
                    padding: 8,
                  },
                },
                {
                  name: 'preventOverflow',
                  enabled: true,
                  options: {
                    altAxis: true,
                    altBoundary: true,
                    tether: true,
                    rootBoundary: 'document',
                    padding: 8,
                  },
                },
                {
                  name: 'arrow',
                  enabled: true,
                },
              ]} open={open}>
                <Box sx={{border: 1, p: 1, bgcolor: 'background.paper', borderRadius: 1, boxShadow: 1}}>
                  {
                    oldValue &&
                    <Box>Wert aus Vorlage:
                      <Box className='w3-padding w3-border w3-margin-top w3-margin-bottom' dangerouslySetInnerHTML={{__html: parseStringFromServer(oldValue)}}>
                      </Box>
                    </Box>
                  }
                  {
                    props.resetToOldValue &&
                    <Button
                      variant="outlined"
                      onClick={props.resetToOldValue}
                    >Lokale Änderung verwerfen</Button>
                  }
                </Box>
              </Popper>
              
            </>
          }
        </span>
        
      }
    </div>
    <div
      className='h2EditInputHolder'
    >
      {
        status !== Status.standard &&
        <InputA
          value={value}
          className='h2EditInput'
          returnVal={(newValue) => {
            setValue(newValue)
            props.onChange(newValue)
            toStandard()
          }}
        />
      }
    </div>
  </>
  switch (props.heading) {
    case 'h1':
      return <Typography
        variant={"h1"} component="h1">{content}</Typography>
    case 'h2':
      return <Typography
        variant={"h2"} component="h2">{content}</Typography>
    case 'h3':
      return <Typography
        variant={"h3"} component="h3">{content}</Typography>
    case 'h4':
      return <Typography
        variant={"h4"} component="h4">{content}</Typography>
    case 'h5':
      return <Typography
        variant={"h5"} component="h5">{content}</Typography>
    case 'h6':
      return <Typography
        variant={"h6"} component="h6">{content}</Typography>
  }
  return <Typography
    variant={"h4"} component="h2"
  >
    {content}
  </Typography>
}
